import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'

import * as state from '../../../../../state'

/**
 * Owns Admin Center route-bound state while the user is inside `/admin`.
 */
@ngCore.Component({
  imports: [ngRouter.RouterOutlet],
  providers: [
    state.routeBound.Registry,
    ...state.admin.provideEntityCollections(),
    ...state.integrations.provideAdminEntityCollections(),
    ...state.quiver.provideEntityCollections(),
  ],
  selector: 'atn-admin-route-boundary',
  standalone: true,
  templateUrl: './component.html',
})
export class Component {}
